import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const ifDeviceNotRegistered = (to, from, next) => {
  if (!store.getters['device/isDeviceRegistered']) {
    next('/settings')
    return
  }
  next()
}

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: 'Smiley Tool Kiosk - Temasek Club' },
    component: () => import('../views/Home.vue'),
    beforeEnter: ifDeviceNotRegistered
  },
  {
    path: '/category',
    name: 'Category',
    meta: { title: 'Smiley Tool Kiosk - Temasek Club' },
    component: () => import('../views/Category.vue'),
    beforeEnter: ifDeviceNotRegistered
  },
  {
    path: '/location',
    name: 'Location',
    meta: { title: 'Smiley Tool Kiosk - Temasek Club' },
    component: () => import('../views/Location.vue'),
    beforeEnter: ifDeviceNotRegistered
  },
  {
    path: '/thank-you',
    name: 'thank-you',
    meta: { title: 'Smiley Tool Kiosk - Temasek Club' },
    component: () => import('../views/ThankYou.vue'),
    beforeEnter: ifDeviceNotRegistered
  },
  {
    path: '/feedback',
    name: 'feedback',
    meta: { title: 'Smiley Tool Kiosk - Temasek Club' },
    component: () => import('../views/Feedback.vue'),
    beforeEnter: ifDeviceNotRegistered
  },
  {
    path: '/register',
    name: 'register-device',
    meta: { title: 'Settings - Temasek Club' },
    component: () => import('../views/ThankYou.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    meta: { title: 'Settings - Temasek Club' },
    component: () => import('../views/Settings.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
